import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "top-selling-items-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mb-lg-20" }
const _hoisted_4 = { class: "trezo-card-content" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "item position-relative" }
const _hoisted_7 = { class: "rating fw-semibold d-flex align-items-center bg-dark text-white" }
const _hoisted_8 = { class: "fw-semibold" }
const _hoisted_9 = { class: "d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "mb-0" }, "Top Selling Items", -1)),
        _createElementVNode("select", {
          class: "form-select month-select bg-gray border-0 form-control",
          "aria-label": "Default select example",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTimeRangeChange && _ctx.handleTimeRangeChange(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("option", {
            value: "Weekly",
            selected: ""
          }, "Weekly", -1),
          _createElementVNode("option", { value: "Monthly" }, "Monthly", -1),
          _createElementVNode("option", { value: "Yearly" }, "Yearly", -1)
        ]))], 32)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topSellingItems.slice(0, 4), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-3 col-sm-6",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-star-fill" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(item.rating), 1)
                ]),
                _createVNode(_component_RouterLink, {
                  to: "/restaurant/dish-details/",
                  class: "d-block image",
                  style: _normalizeStyle({ backgroundImage: `url(${item.image})` })
                }, null, 8, ["style"]),
                _createElementVNode("h6", _hoisted_8, [
                  _createVNode(_component_RouterLink, { to: "/restaurant/dish-details/" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(item.sold) + " sold", 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}